import axios from "../app/axios"

const LogOut = (username,password) =>{
    return axios({redirect401:false}).post("/logout");
}

export default LogOut